<template>
    <div class="ny">
        <div class="main">
                <div class="ny_bt1 mh md20">
                    <span class="bt left">我的申请</span>
                </div>
                <div class="mh md20">
                    <el-button type="primary " @click="open_page('/user/usersuc_sq1')" round>我要申请</el-button>
                </div>
             <div class="mh md30 ta_k">
            <el-table :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" border style="width: 100%;" >
              <el-table-column prop="PatientName" label="受者姓名" width="140">
              </el-table-column>
              <el-table-column prop="Gender" label="性别" width="100">
              </el-table-column>
              <el-table-column prop="Birthday" label="出生日期" width="120">
              </el-table-column>
              <el-table-column prop="Contacts" label="联系人" width="140">
              </el-table-column>
              <el-table-column prop="ApplyDate" label="申请时间" width="165">
              </el-table-column>
              <el-table-column prop="DoctorName" label="主治医生" width="120">
              </el-table-column>
              <el-table-column prop="AuditStatus" label="审批状态" width="222">
              </el-table-column>
              <el-table-column fixed="right"  label="操作" width="180">
                 <template slot-scope="scope">
        <el-button type="primary" size="small" @click="tosqDetail((currentPage-1)*pageSize+scope.$index, tableData)">查看</el-button>
        <el-button type="info" size="small" @click="edit_sp((currentPage-1)*pageSize+scope.$index, tableData)" v-show="tableData[(currentPage-1)*pageSize+scope.$index].IsEdit > 0">修改</el-button>
      <!-- <el-button
          @click.native.prevent="deleteRow(scope.$index, tableData)"
          type="info"
          size="small">
          删除
        </el-button> -->

      </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="mh fy">
              <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[15, 30, 50, 100]"
      :page-size="pageSize"
      background
  layout="prev, pager, next"
      :total="currentTotal">
    </el-pagination>
          </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
import http from "../../http/http";
import api from "../../http/api";
 export default {
  data() {
    return {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        currentTotal: 0,
      }
  },
    mounted() {
    //加载列表
    this.listData();
    // this.delData(9);
  },
  methods: {
    //表格删除
    deleteRow(index, rows) {
         this.$confirm('请确定是否删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           rows.splice(index, 1);
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //删除
       delData: async function (index) {
      let data = {
        UserId:localStorage.getItem('UserId'),
        ApplyId:this.tableData[index].ApplyId
      }
      const res = await http.post(api.apideleteapply, data)
      // console.log(res)
    },
      //列表
      listData: async function () {
      let params = {
        UserId:localStorage.getItem('UserId')
      }
      const res = await http.get(api.apigetlist, params);
      // console.log(res);
      this.tableData=res.data.obj;
       this.currentTotal = this.tableData.length;
    },
     handleSizeChange(val) {
        this.pageSize = val;
        // console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        // console.log(`当前页: ${val}`);
      },
       // 跳转到详情页
      tosqDetail(index, rows) {
        this.$router.push({
          name: "sqDetail",
          query: {
            UserId:localStorage.getItem('UserId'),
            ApplyId:rows[index].ApplyId,
          }
        });
      },
       // 修改
      edit_sp(index, rows) {
        this.$router.push({
          name: "edit_sp",
          query: {
            UserId:localStorage.getItem('UserId'),
            ApplyId:rows[index].ApplyId,
          }
        });
      },
  },
  created: function () {
    // this.$emit('header', false);
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/user/usersplist.vue